module.exports = __webpack_public_path__ + "media/images/official/plancheck_icon_60_2-916717f16e15eac0f6f3604aa7467e31.svg";